import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

interface FooterLink {
  label: string;
  href: string;
}

const BASE_URL = 'https://www.bringliesel.de';

@Component({
  selector: 'app-web-footer',
  templateUrl: './web-footer.component.html',
  styleUrls: ['./web-footer.component.scss'],
  imports: [CommonModule],
})
export class WebFooterComponent {
  readonly columns: FooterLink[][] = [
    [
      { label: 'Service', href: `${BASE_URL}/service/` },
      { label: 'Sortiment', href: `${BASE_URL}/sortiment/` },
      { label: 'Vorteile', href: `${BASE_URL}/vorteile/` },
      { label: 'Häufige Fragen', href: `${BASE_URL}/faq/` },
      { label: 'News', href: `${BASE_URL}/news/` },
    ],
    [
      { label: 'Erfolgsgeschichten', href: `${BASE_URL}/erfolgsgeschichten/` },
      { label: 'Über uns', href: `${BASE_URL}/ueberuns/` },
      { label: 'Presse', href: `${BASE_URL}/presse/` },
      { label: 'Webinare', href: `${BASE_URL}/webinare/` },
      { label: 'Weihnachtsaktion', href: 'https://xmas.bringliesel.de/' },
    ],
    [
      { label: 'Jobs', href: `${BASE_URL}/jobs/` },
      { label: 'Datenschutz', href: `${BASE_URL}/datenschutz/` },
      { label: 'AGB', href: `${BASE_URL}/agb/` },
      {
        label: 'Entsorgung & Batteriegesetz',
        href: `${BASE_URL}/entsorgung-batteriegesetz/`,
      },
      { label: 'Impressum', href: `${BASE_URL}/impressum/` },
    ],
  ];
}
